/*
 * PFC frame hero — animated "fan of frames" visual.
 *
 * Three frame cards (mouldings from the all-mouldings collection) holding the
 * sample photo deal out like a hand of cards on load (pure-CSS animation, see
 * pfc-frame-hero.css), then slowly cross-fade through the moulding pool. Reacts
 * to the gallery's 'pfc-frame-sample' event so an uploaded photo replaces the
 * sample. Frames are drawn with the real moulding texture (ported from
 * pfc-moulding.js); textures load async and are cached.
 */
(function () {
  var root = document.querySelector('[data-pfc-frame-hero]');
  var cfg = window.PFC_FRAME_HERO;
  var POOL = cfg && Array.isArray(cfg.cyclePool) ? cfg.cyclePool.filter(function (m) { return m && m.textureUrl; }) : [];
  if (!root || !cfg || !POOL.length) return;

  var sampleImg = null;
  var texCache = {};
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fhero-card]'));

  /* ---------- Patterned mounts (occasion pages only) ----------
     Ported from pfc-moulding.js drawMountFill. When a card's mount style is set
     and cfg.mounts.enabled, a mount board is drawn between the frame and the
     photo, and the whole assembly is zoomed so it bleeds off the card (canvas
     clips automatically). Disabled → renders byte-identical to a plain frame. */
  var MNT = (cfg && cfg.mounts) || {};
  var MOUNT_BASE = '#fafaf6';
  var MOUNT_PATTERNS = [
    { key: 'vertical', type: 'stripes', bands: 19 },
    { key: 'fine', type: 'stripes', bandWidthMm: 3 },
    { key: 'checker', type: 'checkers', checkMm: 15 }
  ];
  function patternByKey(k) {
    for (var i = 0; i < MOUNT_PATTERNS.length; i++) { if (MOUNT_PATTERNS[i].key === k) return MOUNT_PATTERNS[i]; }
    return MOUNT_PATTERNS[0];
  }
  function stripeBandCount(boardWmm, pat) {
    if (pat.bands) return pat.bands;
    if (pat.bandWidthMm) { var n = Math.round((boardWmm || 210) / pat.bandWidthMm); return n < 5 ? 5 : n; }
    return 19;
  }
  function drawMountFill(c, x, y, w, h, mount, boardWmm) {
    var style = mount && mount.style;
    if (style === 'patterned') {
      var pat = patternByKey(mount.pattern || MNT.pattern);
      var col = mount.colour || MNT.colour || '#23395d';
      c.fillStyle = MOUNT_BASE; c.fillRect(x, y, w, h);
      if (pat.type === 'stripes') {
        var n = stripeBandCount(boardWmm, pat), bw = w / n;
        for (var i = 0; i < n; i++) { c.fillStyle = (i % 2 === 0) ? MOUNT_BASE : col; c.fillRect(x + i * bw, y, Math.ceil(bw) + 1, h); }
      } else if (pat.type === 'checkers') {
        var pxPerMm = w / (boardWmm || 210), cell = Math.max(6, (pat.checkMm || 15) * pxPerMm);
        var cols = Math.ceil(w / cell), rows = Math.ceil(h / cell);
        c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip(); c.fillStyle = col;
        for (var ry = 0; ry < rows; ry++) { for (var cx = 0; cx < cols; cx++) { if ((cx + ry) % 2 === 0) continue; c.fillRect(x + cx * cell, y + ry * cell, Math.ceil(cell) + 1, Math.ceil(cell) + 1); } }
        c.restore();
      }
      return;
    }
    c.fillStyle = (style === 'black') ? '#1a1a1a' : '#fafaf6';
    c.fillRect(x, y, w, h);
  }

  function loadTexture(url, cb) {
    if (!url) { cb(null); return; }
    var c = texCache[url];
    if (c) { if (c.complete) cb(c); else c.addEventListener('load', function () { cb(c); }); return; }
    var im = new Image(); texCache[url] = im;
    im.onload = function () { cb(im); }; im.onerror = function () { cb(null); };
    im.src = url;
  }

  function drawCover(ctx, img, dx, dy, dw, dh) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var s = Math.max(dw / iw, dh / ih);
    ctx.save(); ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
    ctx.drawImage(img, dx + (dw - iw * s) / 2, dy + (dh - ih * s) / 2, iw * s, ih * s);
    ctx.restore();
  }

  function drawFrame(ctx, tex, fw, x0, y0, outerW, outerH, dpr) {
    var hasTex = !!(tex && tex.complete && tex.naturalWidth > 0);
    var frameColour = '#3a2c1d';
    ctx.save();
    ctx.shadowColor = 'rgba(50,38,20,0.30)'; ctx.shadowBlur = 26; ctx.shadowOffsetY = 16;
    ctx.fillStyle = frameColour; ctx.fillRect(x0, y0, outerW, outerH);
    ctx.restore();
    var innerX = x0 + fw, innerY = y0 + fw, innerW = outerW - fw * 2, innerH = outerH - fw * 2;
    function rail(ox1, oy1, ox2, oy2, ix1, iy1, ix2, iy2, gradDir, tx, ty, angle) {
      ctx.save();
      ctx.beginPath(); ctx.moveTo(ox1, oy1); ctx.lineTo(ox2, oy2); ctx.lineTo(ix2, iy2); ctx.lineTo(ix1, iy1); ctx.closePath();
      ctx.clip();
      if (hasTex) {
        ctx.translate(tx, ty); ctx.rotate(angle);
        var sc = fw / tex.naturalHeight; ctx.scale(sc, sc);
        var pat = ctx.createPattern(tex, 'repeat');
        if (pat) { ctx.fillStyle = pat; var md = Math.max(outerW, outerH) / sc; ctx.fillRect(-md, -2, md * 3, tex.naturalHeight + 4); }
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      } else { ctx.fillStyle = frameColour; ctx.fill(); }
      var grad = (gradDir === 'tb') ? ctx.createLinearGradient(ox1, oy1, ix1, iy1) : ctx.createLinearGradient(ox1, oy1, ox2, oy2);
      grad.addColorStop(0, 'rgba(255,255,255,0.09)'); grad.addColorStop(0.4, 'rgba(255,255,255,0.02)'); grad.addColorStop(1, 'rgba(0,0,0,0.10)');
      ctx.fillStyle = grad; ctx.fill();
      ctx.restore();
    }
    rail(x0, y0, x0 + outerW, y0, innerX, innerY, innerX + innerW, innerY, 'tb', x0, y0, 0);
    rail(x0 + outerW, y0 + outerH, x0, y0 + outerH, innerX + innerW, innerY + innerH, innerX, innerY + innerH, 'tb', x0 + outerW, y0 + outerH, Math.PI);
    rail(x0, y0 + outerH, x0, y0, innerX, innerY + innerH, innerX, innerY, 'lr', x0, y0 + outerH, -Math.PI / 2);
    rail(x0 + outerW, y0, x0 + outerW, y0 + outerH, innerX + innerW, innerY, innerX + innerW, innerY + innerH, 'lr', x0 + outerW, y0, Math.PI / 2);
    ctx.strokeStyle = 'rgba(0,0,0,0.22)'; ctx.lineWidth = 1; ctx.strokeRect(innerX + 0.5, innerY + 0.5, innerW - 1, innerH - 1);
    return { x: innerX, y: innerY, w: innerW, h: innerH };
  }

  function renderInto(canvas, finish, mount) {
    var ctx = canvas.getContext('2d'); if (!ctx || !finish) return;
    var useMount = !!(MNT.enabled && mount && mount.style && mount.style !== 'none');
    // Boost the backing-store resolution to the CSS zoom factor so the card
    // stays sharp when its container is scaled up. The "zoom" is a CSS scale on
    // the card element (see --mzoom in pfc-frame-hero.css), NOT a redraw — the
    // frame + mount + photo are always drawn fully inside the canvas.
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (useMount && MNT.zoom > 1) dpr = Math.min(dpr * MNT.zoom, 3);
    var W = Math.max(80, Math.round(canvas.clientWidth || 200));
    var H = Math.max(80, Math.round(canvas.clientHeight || 280));
    if (canvas.width !== W * dpr || canvas.height !== H * dpr) { canvas.width = W * dpr; canvas.height = H * dpr; }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);

    var fw = finish.widthMm || 20;
    var op = cfg.opening;
    var mountU = useMount ? (MNT.widthMm || 40) : 0;
    // Fit the whole frame + mount + photo fully inside the canvas — the moulding
    // is never clipped here. Enlargement is the card's CSS scale, clipped by the fan.
    var outer = { w: op.w + 2 * (fw + mountU), h: op.h + 2 * (fw + mountU) };
    var scale = Math.min(W / outer.w, H / outer.h) * 0.98;
    var outerW = outer.w * scale, outerH = outer.h * scale;
    var x0 = (W - outerW) / 2, y0 = (H - outerH) / 2;
    // drawFrame returns the rect inside the rails — the mount board (or the
    // photo opening directly when there's no mount).
    var board = drawFrame(ctx, texCache[finish.textureUrl], fw * scale, x0, y0, outerW, outerH, dpr);
    if (useMount) {
      var mpx = mountU * scale;
      drawMountFill(ctx, board.x, board.y, board.w, board.h, mount, op.w + 2 * mountU);
      var px = board.x + mpx, py = board.y + mpx, pw = board.w - 2 * mpx, ph = board.h - 2 * mpx;
      if (sampleImg) drawCover(ctx, sampleImg, px, py, pw, ph);
      else { ctx.fillStyle = '#f0ece3'; ctx.fillRect(px, py, pw, ph); }
      // Aperture bevel so the mount reads as a cut board over the photo.
      ctx.strokeStyle = 'rgba(0,0,0,0.16)'; ctx.lineWidth = 1; ctx.strokeRect(px + 0.5, py + 0.5, pw - 1, ph - 1);
    } else {
      if (sampleImg) drawCover(ctx, sampleImg, board.x, board.y, board.w, board.h);
      else { ctx.fillStyle = '#f0ece3'; ctx.fillRect(board.x, board.y, board.w, board.h); }
    }
  }

  /* ---------- Per-card state + cross-fade cycling ---------- */
  var cardState = cards.map(function (el, i) {
    // Mount is a fixed per-card property (style + its own pattern/colour); the
    // moulding pool cycles underneath it, so each card keeps its mount while
    // the frame finishes cross-fade.
    var m = (MNT.enabled && MNT.cards && MNT.cards[i]) || { style: 'none' };
    return { el: el, layers: el.querySelectorAll('canvas'), active: 0, ptr: 0, finish: null, mount: m };
  });
  function offsetFor(i) { return (i * Math.floor(POOL.length / cardState.length)) % POOL.length; }
  var MZOOM = (MNT.enabled && MNT.zoom > 1) ? MNT.zoom : 1;
  cardState.forEach(function (s, i) {
    // A mounted card is CSS-scaled up as a whole (the fan clips the overflow),
    // so the framed+mounted photo reads larger without redrawing or clipping it.
    if (MZOOM > 1 && s.mount && s.mount.style && s.mount.style !== 'none') {
      s.el.style.setProperty('--mzoom', String(MZOOM));
    }
    s.ptr = offsetFor(i); s.finish = POOL[s.ptr];
    loadTexture(s.finish.textureUrl, function () { renderInto(s.layers[0], s.finish, s.mount); });
  });

  function rerenderActive() {
    cardState.forEach(function (s) { if (s.finish) loadTexture(s.finish.textureUrl, function () { renderInto(s.layers[s.active], s.finish, s.mount); }); });
  }
  function cycleCard(i) {
    var s = cardState[i];
    s.ptr = (s.ptr + 1) % POOL.length; s.finish = POOL[s.ptr];
    var next = 1 - s.active;
    loadTexture(s.finish.textureUrl, function () {
      renderInto(s.layers[next], s.finish, s.mount);
      s.layers[next].style.opacity = '1'; s.layers[s.active].style.opacity = '0'; s.active = next;
    });
  }

  /* ---------- Sample photo + reaction to gallery uploads ---------- */
  function loadSample(src) {
    if (!src) return;
    var im = new Image();
    im.onload = function () { sampleImg = im; rerenderActive(); };
    im.crossOrigin = 'anonymous';
    im.src = src;
  }
  loadSample(cfg.sample);
  window.addEventListener('pfc-frame-sample', function (e) {
    var d = (e && e.detail) || {};
    if (d.isPlaceholder) loadSample(cfg.sample);
    else if (d.src) loadSample(d.src);
  });

  /* ---------- Slow loop ---------- */
  var CYC = cfg.cycle || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (CYC.enabled !== false && !reduceMotion) {
    var intervalMs = CYC.intervalMs || 4200;
    var staggerMs = CYC.staggerMs || 260;
    var startDelayMs = CYC.startDelayMs || 3000;
    var tick = function () {
      if (document.hidden) return;
      cardState.forEach(function (_, i) { setTimeout(function () { cycleCard(i); }, i * staggerMs); });
    };
    setTimeout(function () { setInterval(tick, intervalMs); }, startDelayMs);
  }

  var raf = null;
  window.addEventListener('resize', function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(rerenderActive);
  });
})();
